import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './VillageObjectTabPane.css';
import { trackAllObjectsLinkClick, trackBuilderObjectsLinkClick } from './tracking';
import { FatPanelContainer } from '../../../containers/FatPanel';
import { PriceDisclaimerContainer } from '../../../containers/PriceDisclaimerContainer';
import { trackObjectPriceLinkClick } from '../../../tracking';
import { INewobjectCategorySchema } from '../../../types';
import { getAreaBlock, isArrayWithItems, rangePrice } from '../../../utils/helpers';
import { BlockErrorBoundary } from '../../BlockErrorBoundary';
import { ClipboardModify } from '../../common/ClipboardModify';
import { ObjectFotoramaContainer } from '../object_fotorama/container';

interface IProps {
  item: INewobjectCategorySchema;
  isLandplot?: boolean;
  link?: string;
  linkText?: string;
  builderLink?: string;
  builderLinkText?: string;
  resaleLink?: string;
  withResale: boolean;
  hideGallery?: boolean;
  hidePriceByType?: boolean;
}

export const VillageObjectTabPane = (props: IProps) => {
  const { builderLink, builderLinkText, item, isLandplot, link, linkText, hideGallery, hidePriceByType } = props;

  const [galleryState, setGalleryState] = React.useState({ isVisible: false });

  const {
    gallery,
    priceMax,
    priceMin,
    areaMax,
    areaMin,
    description,
    additionalGallery,
    fatTitle,
    fatDescription,
    fatIcon,
  } = item;
  const priceRange = rangePrice(priceMin, priceMax);
  const showNewGallery = additionalGallery && isArrayWithItems(additionalGallery.imageList);
  const priceRangeContent = link ? (
    <a className={styles['price_block']} href={link} onClick={trackObjectPriceLinkClick} target="_blank">
      {priceRange}
    </a>
  ) : (
    <span className={styles['price_block']}>{priceRange}</span>
  );

  const shouldRenderNewGallery = !hideGallery && !!showNewGallery;

  return (
    <div className={styles['container']}>
      {!hideGallery && gallery.imageList && gallery.imageList.length > 1 && !showNewGallery && (
        <div className={styles['images']}>
          <div className={styles['main_image']}>
            <img src={gallery?.imageList?.[0].fullUrl} />
          </div>
          <div className={styles['side_image']}>
            <img src={gallery.imageList[1].fullUrl} />
          </div>
        </div>
      )}
      {(!shouldRenderNewGallery || galleryState.isVisible) && (
        <FatPanelContainer
          containerStyles={mergeStyles(styles['fat_panel'], !shouldRenderNewGallery && styles['fat_panel--old'])}
          title={fatTitle}
          description={fatDescription}
          iconUrl={fatIcon}
        />
      )}
      {shouldRenderNewGallery && (
        <BlockErrorBoundary>
          <ObjectFotoramaContainer
            newObjectCategorySetItem={item}
            onInit={() =>
              setGalleryState({
                isVisible: true,
              })
            }
          />
        </BlockErrorBoundary>
      )}
      {!hidePriceByType && priceRangeContent}
      {areaMin && areaMax && (
        <div className={styles['area_block']}>
          {getAreaBlock(areaMin, areaMax, isLandplot)}
          {!hidePriceByType && <PriceDisclaimerContainer size="16" position="right" />}
        </div>
      )}
      <div className={styles['description']}>
        <ClipboardModify>{description}</ClipboardModify>
      </div>
      <div className={styles['links']}>
        {builderLink && (
          <a className={styles['full_link']} href={builderLink} onClick={trackBuilderObjectsLinkClick} target="_blank">
            Посмотреть {builderLinkText} от застройщика
          </a>
        )}
        {link && (
          <a className={styles['full_link']} href={link} onClick={trackAllObjectsLinkClick} target="_blank">
            Посмотреть {linkText}
          </a>
        )}
      </div>
    </div>
  );
};
